export { default as DocumentAudioSolidIcon } from './DocumentAudioSolidIcon';
